<script setup>
import { computed } from "vue";
import { imageSizePercent } from "../constants";

const props = defineProps({
  card: { type: Object, required: true },
  readonly: { type: Boolean, default: false },
});

const url = computed(() => props.card.content?.url || "");
const caption = computed(() => props.card.content?.caption || "");
const sizeStyle = computed(() => ({ width: `${imageSizePercent(props.card)}%` }));
</script>

<template>
  <figure v-if="url" class="flex flex-col items-center">
    <img :src="url" :style="sizeStyle" class="max-w-full rounded-lg object-contain" />
    <figcaption v-if="caption" class="mt-2 text-center text-13">
      {{ caption }}
    </figcaption>
  </figure>
  <div v-else class="p-4 text-13 text-muted-foreground">Empty image block</div>
</template>
